export const SCREENING_QUESTIONNAIRE_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};
